import { AppRouteProps } from "@bsm/component";
import React from "react";
import { TeacherListViewsRoutes } from "./views/TeacherListViewRoutes";

const TeachersListContainer = React.lazy(() => import('./containers/TeachersListContainer'));

export const TeacherListRoutes: Array<AppRouteProps> = [
    {
        path: "",
        element: <TeachersListContainer />,
        children: [
            ...TeacherListViewsRoutes
        ],
        roles: ["TEACHER"]
    }
]
